import { icons } from "assets/AssetHelper";
import * as dayjs from "dayjs";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("occasions_types.name_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("occasions_types.name_ar"),
        name: data?.localized_data?.ar?.name,
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.datesIcons,
    details: [
      {
        label: t("details.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("details.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
